import { render, staticRenderFns } from "./accounttwofactor.vue?vue&type=template&id=005dd58b&scoped=true&"
import script from "./accounttwofactor.vue?vue&type=script&lang=js&"
export * from "./accounttwofactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005dd58b",
  null
  
)

export default component.exports